import { render, staticRenderFns } from "./UiPlatformsList.vue?vue&type=template&id=faf2bd6c&scoped=true&"
import script from "./UiPlatformsList.vue?vue&type=script&lang=js&"
export * from "./UiPlatformsList.vue?vue&type=script&lang=js&"
import style0 from "./UiPlatformsList.vue?vue&type=style&index=0&id=faf2bd6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2bd6c",
  null
  
)

export default component.exports